<template>
	<QuestionCard
		title="Do you want to use request throttling?"
		description="Time delay in milliseconds between requests to prevent overwhelming the target system."
		show-yes-no-buttons
		:value="useRequestThrottling"
		:disabled="!userFullPermissions"
		@input="setUseRequestThrottling"
	>
		<div
			v-if="useRequestThrottling"
			class="request-throttling-field"
		>
			<TextField
				:value="displayValue"
				label="Request Throttling (milliseconds)"
				class="cassie-input-width-sm"
				type="number"
				:rules="{ required: true, numeric: true, min_value: 1, max_value: maxThrottleMs }"
				:custom-messages="{ max_value: 'Value is too large' }"
				:disabled="!userFullPermissions"
				@input="$emit('update:requestThrottlingWaitTimeMs', $event)"
			/>
		</div>
	</QuestionCard>
</template>

<script>
import TextField from '../../../../../../../shared/components/text-field.vue'
import { QuestionCard } from '../../../../../components/component-library-wrapper.js'
import { MAX_THROTTLE_MS } from '../../service-integration-validator.js'

export default {
	name: 'request-throttling-section',
	components: {
		TextField,
		QuestionCard
	},
	props: {
		requestThrottlingWaitTimeMs: [String, Number],
		userFullPermissions: Boolean
	},
	data () {
		return {
			useRequestThrottling: false
		}
	},
	computed: {
		displayValue () {
			// Ensure 0 is displayed as "0" rather than empty
			if (this.requestThrottlingWaitTimeMs === null || this.requestThrottlingWaitTimeMs === undefined || this.requestThrottlingWaitTimeMs === '') {
				return '0'
			}
			return String(this.requestThrottlingWaitTimeMs)
		},
		maxThrottleMs () {
			return MAX_THROTTLE_MS
		}
	},
	watch: {
		// One-way sync: turn the toggle on when an existing value loads asynchronously
		requestThrottlingWaitTimeMs (newValue) {
			if (Number(newValue) > 0) {
				this.useRequestThrottling = true
			}
		}
	},
	created () {
		this.useRequestThrottling = Number(this.requestThrottlingWaitTimeMs) > 0
	},
	methods: {
		setUseRequestThrottling (value) {
			this.useRequestThrottling = value
			if (!value) {
				// Clear throttling when "No" is selected
				this.$emit('update:requestThrottlingWaitTimeMs', 0)
			} else {
				// Set default value when "Yes" is selected and no meaningful value exists
				const currentValue = Number(this.requestThrottlingWaitTimeMs)
				if (!this.requestThrottlingWaitTimeMs || currentValue <= 0) {
					this.$emit('update:requestThrottlingWaitTimeMs', 1000) // Default to 1 second
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.request-throttling-buttons {
  display: flex;
  gap: 8px;
  align-self: flex-start;
}

.request-throttling-btn {
  min-width: 60px;
  height: 32px;
}

.request-throttling-field {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
